__turbopack_context__.v({
  "brand": "checkbox-module__3PtbiG__brand",
  "icon": "checkbox-module__3PtbiG__icon",
  "indicator": "checkbox-module__3PtbiG__indicator",
  "root": "checkbox-module__3PtbiG__root",
});
